module.exports = __webpack_public_path__ + "25b0d77eb5946d55c0053bfd226a743d.MP3";